import React from "react"
import { Box, Container, useTheme } from "@mui/material"
import { Outlet } from "react-router-dom"

import { useSponsoredFooterBanner } from "hooks/sponsored-content/useSponsoredFooterBanner"

import { Header, HeaderLogo, HeaderTitle } from "components/Header"
import { Clock } from "components/Clock"
import { BackIconButton } from "components/Button"
import { Footer } from "components/Footer"
import { AdMediaFooterCarousel } from "components/domains/ads"
import { useAppUI } from "providers/ui"

export const PageLayout = ({
  children,
  header = null,
  footer = null,
  ...props
}) => {
  const { footerBanners, footerBannerConfig } = useSponsoredFooterBanner()
  const { goBack } = useAppUI()

  const theme = useTheme()
  const styleOverrides = theme.components[`AppPageLayout`]?.styleOverrides || {}
  const { root, headerBackIconContainer, container, footerWrapper } =
    styleOverrides

  return (
    <Box sx={root} {...props} data-name="PageLayout">
      <Header
        logo={<HeaderLogo />}
        title={<HeaderTitle />}
        clock={<Clock />}
        backButton={
          <Box sx={headerBackIconContainer}>
            <BackIconButton onClick={goBack} />
          </Box>
        }
      />
      <Container maxWidth="md" sx={container}>
        <Outlet />
      </Container>
      <Box sx={{ flexGrow: 1 }} />
      <Box sx={footerWrapper}>
        {footerBanners.length > 0 ? (
          <AdMediaFooterCarousel
            data={footerBanners}
            carouselOptions={footerBannerConfig}
          />
        ) : (
          <Footer />
        )}
      </Box>
    </Box>
  )
}
